import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('file');

export const state = () => ({
    ...crud.state,

    QUIZ: 'quiz',
    TEST: 'test',
    SUMMARY: 'summary',
    OTHER: 'other',

    TERM_OPTIONS: ['א׳', 'ב׳', 'ג׳', 'אחר'],

    TYPE_OPTIONS: ['סיכום הרצאות', 'סיכום תרגול', 'אחר'],

    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
});

export const getters = {
    ...crud.getters,

    FILE_TYPE_OPTIONS: state => [
        {
            text: 'Quiz',
            value: state.QUIZ
        },
        {
            text: 'Test',
            value: state.TEST
        },
        {
            text: 'Summary',
            value: state.SUMMARY
        },
        {
            text: 'Other',
            value: state.OTHER
        }
    ],

    TERM_OPTIONS: state => state.TERM_OPTIONS,

    TYPE_OPTIONS: state => state.TYPE_OPTIONS,

    STATUS_PENDING: state => state.PENDING,
    STATUS_APPROVED: state => state.APPROVED,
    STATUS_REJECTED: state => state.REJECTED,

    ALL_STATUSES: state => [
        {
            text: 'Pending',
            value: state.PENDING
        },
        {
            text: 'Approved',
            value: state.APPROVED
        },
        {
            text: 'Rejected',
            value: state.REJECTED
        }
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null,
            isReported = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC',
            isReported
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get('/admin/files', {
            params
        });
    },

    comments(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null,
            id
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/files/${id}/comments`, {
            params
        });
    },

    reports(vuexContext, id) {
        return axios.$get(`admin/files/${id}/reports`);
    },

    status(vuexContext, { id, ...data }) {
        return axios.$post(`admin/files/${id}/status`, data);
    }
};
